import { useCustomCSSEditor } from '../../../hooks/useCustomCSSEditor';
import { IconBorderRadius } from '@bynder/icons';
import { Form, Input } from '@bynder/design-system';
import {
  BUTTON_MAX_RADIUS,
  CSS_PROPERTIES,
  INSPECTOR_DEBOUNCE_DELAY,
} from './constants';
import { useEffect, useState } from 'react';
import { useDebouncedCallback } from 'use-debounce';
import { isDevelopment } from '../../../constants/app';

const InspectorBorderRadius = ({
  style,
  handleStyleChange,
  borderRadius,
  origin,
}: {
  style: string;
  handleStyleChange: (value: string) => void;
  borderRadius: string;
  origin: string;
}) => {
  const { addValueToStyle } = useCustomCSSEditor(style);
  const [value, setValue] = useState(borderRadius);
  const handleCssPropertyChange = (newValue, selector) => {
    const maxRadius = Math.min(
      Number(newValue.split('px')[0]),
      BUTTON_MAX_RADIUS,
    ).toString();
    const newStyle = addValueToStyle(maxRadius + 'px', selector);
    handleStyleChange(newStyle);
  };

  useEffect(() => {
    setValue(borderRadius);
  }, [borderRadius]);

  const debouncedPropertyChange = useDebouncedCallback(
    handleCssPropertyChange,
    INSPECTOR_DEBOUNCE_DELAY,
  );

  const handleChange = (value: string) => {
    setValue(value);
    debouncedPropertyChange(value + 'px', CSS_PROPERTIES.BORDER_RADIUS);
  };

  return (
    <Form.Group>
      <Input
        type="number"
        icon={<IconBorderRadius />}
        suffix="px"
        value={value}
        onChange={handleChange}
      />
      {isDevelopment && (
        <Form.HelperText>{`origin: ${origin}`}</Form.HelperText>
      )}
    </Form.Group>
  );
};
export default InspectorBorderRadius;
